import { render, staticRenderFns } from "./shipment-bill-generate.vue?vue&type=template&id=3f4f220e&scoped=true&"
import script from "./shipment-bill-generate.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-generate.vue?vue&type=script&lang=js&"
import style0 from "./shipment-bill-generate.vue?vue&type=style&index=0&id=3f4f220e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f220e",
  null
  
)

export default component.exports